import { render, staticRenderFns } from "./electrical_meter_card.vue?vue&type=template&id=585c707b&"
import script from "./electrical_meter_card.vue?vue&type=script&lang=js&"
export * from "./electrical_meter_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports